import { render } from "./leftSideBar.vue?vue&type=template&id=8c327e86"
import script from "./leftSideBar.vue?vue&type=script&lang=js"
export * from "./leftSideBar.vue?vue&type=script&lang=js"

import "./leftSideBar.vue?vue&type=style&index=0&id=8c327e86&lang=scss"

import exportComponent from "C:\\Users\\DELL\\source\\repos\\project0810frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
export default /*#__PURE__*/exportComponent(script, [['render',render]])